<style>
.bg-readonly input, .bg-readonly textarea {
    background-color: rgb(235, 235, 235);
}
.remove-button, .add-button {
  font-size: 1.5em;
  background-color: #ff5c5c; /* Red color for remove button */
  color: #fff; /* White text color for buttons */
  border: none;
  cursor: pointer;
  padding: 0.2em 0.5em;
  margin: 0.2em;
  border-radius: 5px;
}
.add-button {
  background-color: #5cb85c; /* Green color for add button */
}
.combo-row td {
  border-bottom: 1px solid #e5e5e5;
}
</style>
<template>
    <vx-card :title="'Create Inbound - Customer Return Form'">
        <div class="vx-row mb-6" style="width: 50%">
            <vs-button class="ml-4 mt-2" color="danger" icon-pack="feather" icon="icon-arrow-left"
                @click="handleBack()">Back</vs-button>
        </div>
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center">
                <span>Customer/Ship-to Code</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input :value="data.customer_code" :readonly="true" class="w-full bg-readonly"></vs-input>
            </div>
        </div>
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center">
                <span>SO/Invoice Code</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input :value="data.inv_code" :readonly="true" class="w-full bg-readonly"></vs-input>
            </div>
        </div>
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center">
                <span>Sales Return Data</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input :value="data.sales_return_data " :readonly="true" class="w-full bg-readonly"></vs-input>
            </div>
        </div>
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center">
                <span>GIR Data</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input :value="data.gir_data " :readonly="true" class="w-full bg-readonly"></vs-input>
            </div>
        </div>
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center">
                <span>Posting Date</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <!-- <Date :value="this.data.receive_date" @selected="(val) => {
                    this.data.receive_date = val
                }"></Date> -->
                <datepicker name="date" :inline="false" format="yyyy-MM-dd"
                    v-model="data.receive_date" placeholder="Select Date"
                    :disabled-dates="disabledDatesObj"
                    :cleared="() => {
                        data.receive_date = null
                    }">
                </datepicker>
            </div>
        </div>
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center">
                <span>Return Type</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-input :value="data.return_type " :readonly="true" class="w-full bg-readonly"></vs-input>
            </div>
        </div>
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center">
                <span>Note</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <vs-textarea :readonly="statusReadonly" v-model="data.note" width="100%" :class="statusReadonly ? 'bg-readonly' : ''"/>
            </div>
        </div>
        <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/3 w-full flex items-center">
                <span>Attachment</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <input type="file" ref="attechment" accept=".jpg,.jpeg, .png" @change="handleChangeAttachment" />

            </div>
        </div>
        <div class="vx-row mb-6" style="width: 50%" v-if="this.data.fileUrl != ''">
            <div class="vx-col sm:w-1/3 w-full flex items-center">

            </div>
            <div class="vx-col sm:w-2/3 w-full">
                <div class="op-block mt-5">
                    <vs-list>
                        <vs-list-item title="File 1">
                            <div class="vx-input-group flex">
                                <vs-button size="small" color="success" icon-pack="feather" icon="icon-download"
                                    title="Download" class="mr-1" @click="openTab(data.fileUrl)" />
                                <!-- <vs-button size="small" color="danger" icon-pack="feather" icon="icon-trash"
                                    title="Delete" /> -->
                            </div>
                        </vs-list-item>
                    </vs-list>
                </div>
            </div>
        </div>

        <vs-divider style="width: 100%; margin-left: 0%">Log Approval</vs-divider>
          <vs-table
            stripe
            border
            description
            :sst="true"
            :data="data.historyNotes"
          >
            <template slot="thead">
              <vs-th>Time</vs-th>
              <vs-th>User</vs-th>
              <vs-th>Status & Note</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td class="whitespace-no-wrap">{{ formatDateTime(tr.created_at) }}</vs-td>
                <vs-td class="whitespace-no-wrap">{{ tr.personal_name }}</vs-td>
                <vs-td class="whitespace-no-wrap">{{ tr.type }}. {{ tr.notes }}</vs-td>
              </vs-tr>
            </template>
        </vs-table>
        <vs-divider style="width: 100%; margin-left: 0%"></vs-divider>

        <div class="vx-row mb-6">
            <div class="vx-col w-full mb-6">
                <table width="100%" class="vs-table vs-table--tbody-table mb-6">
                    <thead class="vs-table--thead">
                        <tr>
                            <th width="7%">SKU Code</th>
                            <th width="15%">SKU Description</th>
                            <th width="5%">Return HU</th>
                            <th width="4%">Return Qty</th>
                            <template v-if="data.shipment_number !== '' && data.shipment_number !== null">
                                <th width="4%">Pickup Qty</th>
                            </template>
                            <th width="12%">Supplier</th>
                            <th width="6%">Receive HU</th>
                            <th width="5%">Receive Qty</th>
                            <th width="5%">Delta Qty Pcs</th>
                            <th width="10%">ED</th>
                            <th width="8%">Batch</th>
                            <th width="10%">Checked Status</th>
                            <th width="7%">Shelf Life Status</th>
                            <th width="5%"></th>
                        </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in normalItems" :key="'normal-' + item.uid" style="padding-bottom: 5px">
                        <td class="td vs-table--td" style="padding: 5px">
                          <vs-input :value="item.item_code" :readonly="true" class="w-full bg-readonly" v-show="!item.hideFields"></vs-input>
                        </td>
                        <td class="td vs-table--td" style="padding: 5px">
                          <vs-input :value="item.item_name" :readonly="true" class="w-full bg-readonly" v-show="!item.hideFields"></vs-input>
                        </td>
                        <td class="td vs-table--td" style="padding: 5px">
                          <vs-input :value="item.item_unit" :readonly="true" class="w-full bg-readonly" v-show="!item.hideFields"></vs-input>
                          <!-- <input type="hidden" :value="item.item_unit_id" /> -->
                        </td>
                        <td class="td vs-table--td" style="padding: 5px">
                          <vs-input :value="item.quantity" :readonly="true" class="w-full bg-readonly" v-show="!item.hideFields"></vs-input>
                        </td>
                        <template v-if="item.pickup_qty !== 0 && data.shipment_number !== '' && data.shipment_number !== null">
                            <td class="td vs-table--td" style="padding: 5px">
                                <vs-input :value="item.pickup_qty" :readonly="true" class="w-full bg-readonly" v-show="!item.hideFields"></vs-input>
                            </td>
                        </template>
                        <td class="td vs-table--td" style="padding: 5px">
                            <SupplierSelect 
                                :key="item.item_id + '-' + index"
                                :value="item.supplier"
                                :base-url="`/api/wms/v1/inbound/sales-return-receive/supplier/${item.item_id}`"
                                label="name" track-by="name" @selected="(v) => {
                                    // const ri = getItemIndex(item.uid);
                                    item.supplier = v;
                                    item.supplier_id = v.id;
                                    item.supplier_code = v.code;

                                    // if (shelfLifeLoaded) {
                                    //     updateShelfLife(index);
                                    // }
                                }"></SupplierSelect>
                        </td>
                        <td class="td vs-table--td" style="padding: 5px">
                            <CustomMSelect 
                                :key="item.item_id + '-' + index"    
                                :value="item.item_unit_receive"
                                :base-url="`/api/wms/v1/master/item-unit/item/${item.item_id}`"
                                label="name" track-by="name" @selected="(v) => {
                                    const ri = getItemIndex(item.uid);
                                    item.item_unit_receive = v;
                                    item.item_unit_id = v.id;
                                    item.amount_uom_receive = v.amount_uom;
                                    updateAmountUom(ri);
                                }"></CustomMSelect>
                        </td>
                        <td class="td vs-table--td" style="padding: 5px">
                          <vs-input type="text" @input="calculate(getItemIndex(item.uid))" v-model="item.qty" class="w-full"></vs-input>
                        </td>
                        <td class="td vs-table--td" style="padding: 5px">
                          <vs-input :value="item.delta_quantity" :readonly="true" class="w-full bg-readonly"></vs-input>
                        </td>
                        <td class="td vs-table--td" style="padding: 5px">
                            <template v-if="item.expired_date_from_so !== null && item.expired_date_from_so !== '' && item.expired_date_from_so !== undefined ">
                                <!-- CR-2600055 -->
                                <datepicker name="date" :inline="false" format="yyyy-MM-dd"
                                    v-model="item.expired_date" placeholder="Select Date"
                                    @input="updateBatch(index)"
                                    :cleared="() => {
                                        item.expired_date = null
                                    }">
                                </datepicker>
                            </template>
                            <template v-else-if="item.setting_ed == '0'">
                                <vs-input :value="item.expired_date" :readonly="true" class="w-full bg-readonly"></vs-input>
                            </template>
                            <template v-else>
                                <datepicker name="date" :inline="false" format="yyyy-MM-dd"
                                    v-model="item.expired_date" placeholder="Select Date"
                                    @input="updateBatch(getItemIndex(item.uid))"
                                    :cleared="() => {
                                        item.expired_date = null
                                    }">
                                </datepicker>
                            </template>
                        </td>
                        <td class="td vs-table--td" style="padding: 5px">
                            <template v-if="item.batch_so !== null && item.batch_so !== ''">
                                <vs-input type="text" v-model="item.batch" class="w-full"></vs-input>
                            </template>
                            <template v-else-if="item.batch_external !== null && item.batch_external !== ''">
                                <vs-input :value="item.batch" :readonly="true" class="w-full bg-readonly"></vs-input>
                            </template>
                            <template v-else-if="item.setting_batch !== 'Batch'">
                                <vs-input :value="item.batch" :readonly="true" class="w-full bg-readonly"></vs-input>
                            </template>
                            <template v-else>
                                <vs-input type="text" v-model="item.batch" class="w-full"></vs-input>
                            </template>
                        </td>
                        <td class="td vs-table--td" style="padding: 5px">
                            <v-select 
                                v-model="item.checked_status_value" 
                                :options="statusOptions" 
                            />
                        </td>
                        <td class="td vs-table--td" style="padding: 5px">
                            <vs-textarea
                                :value="item.shelf_life_status_view"
                                readonly
                                height="80px"
                            />
                        </td>
                        <td class="td vs-table--td" style="padding: 5px">
                          <button @click="removeItem(getItemIndex(item.uid))" v-if="getItemIndex(item.uid) !== 0 && items[getItemIndex(item.uid)].hideFields" class="remove-button">&#45;</button>
                          <button :disabled="item.child_item || item.qty == 0" @click="addItem(getItemIndex(item.uid))" v-else class="add-button">&#43;</button>
                        </td>
                      </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <vs-divider style="width: 100%; margin-left: 0%">Combo Items</vs-divider>

        
        <div class="vx-row mb-6">
            <div class="vx-col w-full mb-6">
                <table width="100%" class="vs-table vs-table--tbody-table mb-6">
                    <thead class="vs-table--thead">
                        <tr>
                            <th width="15%">Combo Information</th>
                            <th width="5%">Receive Qty</th>
                            <th width="7%">SKU Code</th>
                            <th width="15%">SKU Description</th>
                            <th width="6%">HU</th>
                            <!-- <th width="5%">Return Qty</th> -->
                            <th width="5%">Qty</th>
                            <th width="12%">Supplier</th>
                            <th width="10%">ED</th>
                            <th width="8%">Batch</th>
                            <th width="10%">Checked Status</th>
                            <th width="7%">Shelf Life Status</th>
                            <th width="5%"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="group in groupedComboItems">
                            <tr
                            v-for="(item, index) in group.items"
                            :key="'group-' + group.combo_id + '-item-' + item.uid"
                            class="combo-row"
                            :style="index === 0
                                ? 'border-top: 2px solid #d8d8d8; padding-bottom: 5px;'
                                : 'padding-bottom: 5px;'"
                            >
                            <!-- Combo info hanya tampil di baris pertama -->
                            <td
                                v-if="index === 0 && isFirstComboGroup(group)"
                                class="td vs-table--td"
                                style="padding: 5px; background: #fafafa;"
                                :rowspan="comboItems.filter(i => i.combo_id === group.combo_id).length"
                                >
                                <div>
                                    <strong>Combo Code :</strong> {{ group.combo_code }} <br>
                                    <strong>Combo Name :</strong> {{ group.combo_name }} <br>
                                    <strong>Qty :</strong> {{ group.qty_combo }} SET
                                </div>

                                <div
                                    v-for="comboItem in group.items.filter(item => !item.is_child_combo)"
                                    :key="'combo-info-' + comboItem.uid"
                                    style="margin-top: 8px; padding-top: 6px; border-top: 1px dashed #d8d8d8;"
                                >
                                    <strong>{{ comboItem.item_code }}</strong><br>
                                    {{ comboItem.item_name }}<br>
                                    Qty : {{ comboItem.quantity }}
                                </div>
                            </td>

                            <!-- Receive qty hanya tampil di baris pertama -->
                            <td
                                v-if="index === 0"
                                class="td vs-table--td"
                                style="padding: 5px"
                                :rowspan="group.items.length"
                            >
                                <vs-input
                                    type="text"
                                    :value="group.combo_qty_receive"
                                    @input="(v) => calculateCombo(group, v)"
                                    class="w-full"
                                />
                            </td>

                            <!-- Detail item -->
                            <td class="td vs-table--td" style="padding: 5px">
                                <vs-input :value="item.item_code" readonly class="w-full bg-readonly" />
                            </td>

                            <td class="td vs-table--td" style="padding: 5px">
                                <vs-input :value="item.item_name" readonly class="w-full bg-readonly" />
                            </td>

                            <td class="td vs-table--td" style="padding: 5px">
                                <vs-input :value="item.item_unit" readonly class="w-full bg-readonly" />
                            </td>

                            <!-- <td class="td vs-table--td" style="padding: 5px">
                                <vs-input :value="item.quantity" readonly class="w-full bg-readonly" />
                            </td> -->

                            <td class="td vs-table--td" style="padding: 5px">
                                <vs-input type="text" @input="calculateChildCombo(getItemIndex(item.uid))" v-model="item.qty" class="w-full"></vs-input>
                                <!-- <vs-input :value="item.qty" readonly class="w-full bg-readonly" /> -->
                            </td>

                            <td class="td vs-table--td" style="padding: 5px">
                                <SupplierSelect
                                :key="item.item_id + '-' + item.uid"
                                :value="item.supplier"
                                :base-url="`/api/wms/v1/inbound/sales-return-receive/supplier/${item.item_id}`"
                                label="name"
                                track-by="name"
                                @selected="(v) => {
                                    // const ri = getItemIndex(item.uid);
                                    item.supplier = v
                                    item.supplier_id = v.id
                                    item.supplier_code = v.code

                                    // if (shelfLifeLoaded) {
                                    //     updateShelfLife(ri);
                                    // }
                                }"
                                />
                            </td>

                            <td class="td vs-table--td" style="padding: 5px">
                                <template v-if="item.expired_date_from_so !== null && item.expired_date_from_so !== '' && item.expired_date_from_so !== undefined ">
                                    <vs-input :value="formatDate(item.expired_date)" :readonly="true" class="w-full bg-readonly"></vs-input>
                                </template>
                                <template v-else-if="item.setting_ed == '0'">
                                    <vs-input :value="item.expired_date" :readonly="true" class="w-full bg-readonly"></vs-input>
                                </template>
                                <template v-else>
                                    <datepicker name="date" :inline="false" format="yyyy-MM-dd"
                                        v-model="item.expired_date" placeholder="Select Date"
                                        @input="updateBatch(getItemIndex(item.uid))"
                                        :cleared="() => {
                                            item.expired_date = null
                                        }">
                                    </datepicker>
                                </template>
                            </td>

                            <td class="td vs-table--td" style="padding: 5px">
                                <template v-if="item.batch_external !== null && item.batch_external !== ''">
                                    <vs-input :value="item.batch" :readonly="true" class="w-full bg-readonly"></vs-input>
                                </template>
                                <template v-else-if="item.setting_batch !== 'Batch'">
                                    <vs-input :value="item.batch" :readonly="true" class="w-full bg-readonly"></vs-input>
                                </template>
                                <template v-else>
                                    <vs-input type="text" v-model="item.batch" class="w-full"></vs-input>
                                </template>
                            </td>

                            <td class="td vs-table--td" style="padding: 5px">
                                <v-select
                                v-model="item.checked_status_value"
                                :options="statusOptions"
                                />
                            </td>

                            <td class="td vs-table--td" style="padding: 5px">
                                <vs-textarea
                                :value="item.shelf_life_status_view"
                                readonly
                                height="80px"
                                />
                            </td>

                            <td class="td vs-table--td" style="padding: 5px">
                                <button @click="removeItem(getItemIndex(item.uid))" v-if="getItemIndex(item.uid) !== 0 && items[getItemIndex(item.uid)].hideFields" class="remove-button">&#45;</button>
                                <button :disabled="item.child_item || item.qty == 0" @click="addItemChildCombo(getItemIndex(item.uid))" v-else class="add-button">&#43;</button>
                            </td>

                            <!-- Tombol add/remove hanya tampil sekali -->
                            <!-- <td
                                v-if="index === 0"
                                class="td vs-table--td"
                                style="padding: 5px"
                                :rowspan="group.items.length"
                                >
                                <button
                                    @click="removeItemCombo(group)"
                                    v-if="group.items.some(i => i.child_item)"
                                    class="remove-button"
                                >
                                    &#45;
                                </button>

                                <button
                                    :disabled="group.child_item || group.qty == 0"
                                    @click="addItemCombo(group)"
                                    v-else
                                    class="add-button"
                                >
                                    &#43;
                                </button>
                            </td> -->
                            </tr>

                        </template>
                    </tbody>
                </table>
            </div>
        </div>
          <div class="vx-row mb-6" style="width: 50%">
            <div class="vx-col sm:w-1/1 w-full">
                <div
                style="
                    position: absolute;
                    left: 50%;
                    -ms-transform: translate(-50%, -50%);
                    transform: translate(-50%, -50%);
                ">
                    <vs-button v-if="hasPermission('create')" class="mr-2 mb-3" @click="handleSubmit(false)">Save to draft</vs-button>
                    <vs-button v-if="hasPermission('create')" class="mb-2 mr-3" @click="handleSubmit(true)">Save and Confirm</vs-button>
                </div>
            </div>
        </div>
        <!-- <vs-popup title="Information" :active.sync="showShelfLifeError">
            <div style="text-align:left">
                <p>The following SKUs do not have shelf life configured:</p>
                <ul>
                <li v-for="(item, i) in invalidShelfLifeList" :key="i">
                    {{ item.item_code }} - {{ item.item_name }}
                </li>
                </ul>
            </div>
        </vs-popup> -->
        <vs-prompt :active.sync="showErrorDialog" title="Information" color="danger" @accept="showErrorDialog = false">
            <ul>
                <li v-for="(msg, index) in errorMessages" :key="index" style="margin-bottom: 4px;">
                    {{ msg }}
                </li>
            </ul>
        </vs-prompt>
    </vx-card>
</template>

<script>

import _ from "lodash";
import Warehouse from "@/components/Warehouse.vue";
import Date from "@/components/Date.vue";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import CustomMSelect from "@/components/CustomMultiSelect.vue";
import SupplierSelect from "./component/Supplier.vue";

import vSelect from "vue-select";
export default {
    components: {
        Warehouse,
        Date,
        Datepicker,
        vSelect,
        CustomMSelect,
        SupplierSelect
    },
    data() {
        return {
            data: {
                id: null,
                customer_code: null,
                so_code: null,
                inv_code: null,
                code: null,
                gir_number: null,
                sales_return_data: null,
                gir_data: null,
                receive_date: null,
                note: null,
                file: null,
                status: null,
                srr_id: null,
                tpr_id: null,
                fileUrl: '',
                setting: '',
                is_partial: '',
                shipment_number: '',
                return_type: '',
                is_withreff: false,
                historyNotes: [],
              },
            items: [],
            // normalItems: [],
            // comboItems: [],
            statusOptions: [
                { label: 'Good', value: 'Good' },
                { label: 'Bad', value: 'Bad' },
                { label: 'Expired', value: 'Expired' },
            ],
            statusReadonly: false,
            permission: [],
            shelfLifeLoaded: false,
            showShelfLifeError: false,
            invalidShelfLifeList: [],
            showErrorDialog: false,
        }
    },
    mounted() {
        // var now = moment()
        // this.data.receive_date = now
        // now.add(1, 'days')

        this.id = this.$route.params.id;
        if (this.id) { // sto id
            this.getData()
        }
        this.getPermission();
    },
    methods: {
        updateBatch(index) {
            // console.log("DATA ITEM",this.items[index])
            const formattedDate = moment(this.items[index].expired_date).format('YYYYMMDD');
            this.items[index].batch = `${formattedDate}`;
            // update status shelf life
            // this.calculateShelfLifeStatus(index);
        },
        updateAmountUom(index) {
            // console.log("DATA ITEM",this.items[index])
            if (this.items[index].qty != null && this.items[index].qty !== 0) {
                const currentItem = this.items[index];
                let previousDeltaQuantity = 0; // Menyimpan nilai delta dari loop sebelumnya

                this.items.forEach((val, idx) => {
                    // Cek kelompok item berdasarkan kode, unit, dan quantity
                    if (val.item_code === currentItem.item_code &&
                        val.item_unit === currentItem.item_unit &&
                        val.quantity === currentItem.quantity) {

                        if (val.hideFields === false) {
                            // Iterasi pertama untuk kelompok item (hideFields == false)
                            if (val.pickup_qty && val.pickup_qty !== 0) {
                                // Jika ada pickup_qty, gunakan dalam perhitungan
                                val.delta_quantity = (val.pickup_qty * val.amount_uom) - (val.qty * val.amount_uom_receive);
                            } else if(val.qty && val.qty !== 0){
                                // Jika tidak ada pickup_qty, gunakan quantity
                                val.delta_quantity = (val.quantity * val.amount_uom) - (val.qty * val.amount_uom_receive);
                            }
                            // Set nilai delta_quantity ini sebagai nilai awal untuk iterasi berikutnya
                            previousDeltaQuantity = val.delta_quantity;
                        } else {
                            // Iterasi selanjutnya dalam kelompok (hideFields == true)
                            // Menggunakan delta_quantity dari iterasi sebelumnya
                            val.delta_quantity = previousDeltaQuantity - (val.qty * val.amount_uom_receive);
                            // Perbarui nilai previousDeltaQuantity untuk digunakan dalam iterasi berikutnya
                            previousDeltaQuantity = val.delta_quantity;
                        }
                    }
                });
            }
        },
        addItem(index) {
          // Check if the current row has already added a new row
          if (!this.items[index].hideFields) {
            if(this.items[index].qty == null || this.items[index].qty == 0){
                this.$vs.dialog({
                    type: 'alert',
                    color: 'danger',
                    title: 'Information',
                    text: 'Please insert receive qty first!',
                    acceptText: 'OK',
                });
            } else {
                console.log('INDEX',index)
                    let count = index;
                    this.items.forEach((val) => {
                        if (val.item_code === this.items[index].item_code && val.item_unit === this.items[index].item_unit && val.quantity === this.items[index].quantity && val.sales_return_line_id === this.items[index].sales_return_line_id) {
                            count++;
                        }
                    });
                    let parent_delta = 0;
                    if(count > 0){
                        let indexParent = count - 1;
                        console.log("index count",indexParent);
                        parent_delta = this.items[indexParent].delta_quantity
                    }
                    const newItem = {
                        item_code: this.items[index].item_code,
                        item_name: this.items[index].item_name,
                        item_unit: this.items[index].item_unit,
                        // item_unit_id: this.items[index].item_unit_id,
                        quantity: this.items[index].quantity,
                        pickup_qty: this.items[index].pickup_qty,
                        qty: '',
                        delta_quantity: parent_delta,
                        delta_quantity_parent: parent_delta,
                        batch: this.items[index].batch,
                        expired_date: this.items[index].expired_date,
                        checked_status_value: this.items[index].checked_status_value,
                        setting_ed : this.items[index].setting_ed,
                        expired_date_from_so : this.items[index].expired_date_from_so,
                        setting_batch : this.items[index].setting_batch,
                        batch_external : this.items[index].batch_external,
                        hideFields: true, // Set the flag to true for the current row
                        supplier_code: this.items[index].supplier_code,
                        supplier_id: this.items[index].supplier_id,
                        supplier: this.items[index].supplier,
                        item_id: this.items[index].item_id,
                        amount_uom: this.items[index].amount_uom,
                        sales_return_line_id: this.items[index].sales_return_line_id,
                        shelf_life_id: this.items[index].shelf_life_id,
                        shelf_life_day: this.items[index].shelf_life_day,
                        shelf_life_status: this.items[index].shelf_life_status,
                        shelf_life_status_view: this.items[index].shelf_life_status_view,
                        combo_id: this.items[index].combo_id,
                        uid: Math.random().toString(36).substring(2),
                    };
                    if(index == 0){
                        this.items.splice(count, 0, newItem);
                    } else {
                        console.log("INDEX",index)
                        console.log("COUNT",count)
                        console.log("VALUE INDEX",index + count)
                        this.items.splice(count, 0, newItem);
                    }
            }
            }
            const itemCounts = {};
            this.items.forEach((val) => {
                const itemCode = val.item_code + " - " + val.item_unit;
                itemCounts[itemCode] = (itemCounts[itemCode] || 0) + 1;
            });

            // Set child_item flag based on the count
            this.items.forEach((val, i) => {
                if (itemCounts[val.item_code] > 2) {
                    this.items[i].child_item = true;
                }
            });
        //   console.log('lenght',this.items[index].item_code)
        //   if(this.items.length == 3){
        //       this.items[index].child_item = true;
        //   }
        },
        addItemChildCombo(index) {
          // Check if the current row has already added a new row
          if (!this.items[index].hideFields) {
            if(this.items[index].qty == null || this.items[index].qty == 0){
                this.$vs.dialog({
                    type: 'alert',
                    color: 'danger',
                    title: 'Information',
                    text: 'Please insert receive qty first!',
                    acceptText: 'OK',
                });
            } else {
                console.log('INDEX',index)
                    let count = index;
                    this.items.forEach((val) => {
                        if (val.item_code === this.items[index].item_code && val.item_unit === this.items[index].item_unit && val.quantity === this.items[index].quantity) {
                            count++;
                        }
                    });
                    let parent_delta = 0;
                    if(count > 0){
                        let indexParent = count - 1;
                        console.log("index count",indexParent);
                        parent_delta = this.items[indexParent].delta_quantity
                    }
                    const newItem = {
                        item_code: this.items[index].item_code,
                        item_name: this.items[index].item_name,
                        item_unit: this.items[index].item_unit,
                        item_unit_id: this.items[index].item_unit_id,
                        quantity: this.items[index].quantity,
                        pickup_qty: this.items[index].pickup_qty,
                        qty: '',
                        delta_quantity: parent_delta,
                        delta_quantity_parent: parent_delta,
                        batch: this.items[index].batch,
                        expired_date: this.items[index].expired_date,
                        checked_status_value: this.items[index].checked_status_value,
                        setting_ed : this.items[index].setting_ed,
                        expired_date_from_so : this.items[index].expired_date_from_so,
                        setting_batch : this.items[index].setting_batch,
                        batch_external : this.items[index].batch_external,
                        hideFields: true, // Set the flag to true for the current row
                        supplier_code: this.items[index].supplier_code,
                        supplier_id: this.items[index].supplier_id,
                        supplier: this.items[index].supplier,
                        item_id: this.items[index].item_id,
                        amount_uom: this.items[index].amount_uom,
                        sales_return_line_id: this.items[index].sales_return_line_id,
                        shelf_life_id: this.items[index].shelf_life_id,
                        shelf_life_day: this.items[index].shelf_life_day,
                        shelf_life_status: this.items[index].shelf_life_status,
                        shelf_life_status_view: this.items[index].shelf_life_status_view,
                        combo_id: this.items[index].combo_id,
                        combo_name: this.items[index].combo_name,
                        combo_group: this.items[index].combo_group,
                        combo_code: this.items[index].combo_code,
                        combo_qty_receive: this.items[index].combo_qty_receive,
                        qty_combo: this.items[index].qty_combo,
                        qty_per_set: this.items[index].qty_per_set,
                        item_unit_id_return: this.items[index].item_unit_id_return,
                        is_child_combo: true,
                        uid: Math.random().toString(36).substring(2),
                    };
                    if(index == 0){
                        this.items.splice(count, 0, newItem);
                    } else {
                        console.log("INDEX",index)
                        console.log("COUNT",count)
                        console.log("VALUE INDEX",index + count)
                        this.items.splice(count, 0, newItem);
                    }
            }
            }
            const itemCounts = {};
            this.items.forEach((val) => {
                const itemCode = val.item_code + " - " + val.item_unit;
                itemCounts[itemCode] = (itemCounts[itemCode] || 0) + 1;
            });

            // Set child_item flag based on the count
            this.items.forEach((val, i) => {
                if (itemCounts[val.item_code] > 2) {
                    this.items[i].child_item = true;
                }
            });
        },
        removeItem(index) {
          this.items.splice(index, 1);
          this.items[index-1].child_item = false;
        },
        getData() {
          console.log('tes',this.$store.state.inbound.customerReturn.baseUrlPath  + "/" + this.id)
            this.$vs.loading();
            this.$http
                .get(this.$store.state.inbound.customerReturn.baseUrlPath + "/create" + this.id)
                .then((resp) => {
                    if (resp.code == 200) {
                        var now = moment().toDate();
                        console.log("DATA",resp.data)
                        this.data.id = resp.data.sr_id
                        this.data.customer_code = resp.data.customer_code
                        this.data.inv_code = resp.data.inv_code
                        this.data.so_code = resp.data.so_code
                        this.data.so_id = resp.data.so_id
                        this.data.sales_return_data = resp.data.code + " " + resp.data.gir_number
                        this.data.code = resp.data.code
                        this.data.gir_number = resp.data.gir_number
                        this.data.receive_date = resp.data.receive_date == null ? now : resp.data.receive_date
                        this.data.tpr_id = resp.data.tpr_id ? resp.data.tpr_id : 0
                        this.data.note = resp.data.note
                        this.data.status = resp.data.status
                        this.data.srr_id = resp.data.srr_id
                        this.data.wh_id = resp.data.wh_id   
                        this.data.setting = resp.data.setting.value
                        this.data.shipment_number = resp.data.shipment_number
                        if (resp.data.return_type && resp.data.return_type == "1"){
                            this.data.return_type = "Full"
                        } else if(resp.data.return_type && resp.data.return_type == "0"){
                            this.data.return_type = "Partial"
                        }
                        console.log("setting putaway",this.data.setting)
                        console.log("Data Line",resp.data.lines)
                        var sameitem = ""
                        if(resp.data.so_id > 0){
                            this.data.is_withreff = true
                        }
                        resp.data.lines.forEach(el =>{
                            let amountUomReceive = 0
                            let returnQty = 0
                            let pickupQty = 0
                            let batch = ""
                            let batch_external_so = ""
                            let expired_date = null
                            if(el.adjusted_quantity){
                                pickupQty = el.adjusted_quantity
                                this.data.shipment_number = resp.data.shipment_number == "" ? 'MANUAL' : resp.data.shipment_number
                            }
                            returnQty = el.quantity

                            if(el.expired_date_so != null){
                                expired_date = el.expired_date_so
                            } else if (el.is_expired == "0"){
                                expired_date = moment().add(1, 'years').format('YYYY-MM-DD');
                            } else {
                                expired_date = el.expired_date
                            }
                            console.log("expired date so",el.expired_date_so)
                            if(el.batch_so != null && el.batch_so != ''){
                                batch = el.batch_so.includes('#')
                                        ? el.batch_so.split('#')[0]
                                        : el.batch_so
                                batch_external_so = el.batch_so.includes('#')
                                        ? el.batch_so.split('#')[0]
                                        : el.batch_so
                            } else if(el.batch_external != null && el.batch_external != ''){
                                console.log("cek")
                                batch = el.batch_external
                            } else if (el.name != 'Batch'){
                                console.log("expired date",expired_date)
                                if(expired_date != null && expired_date != ''){
                                    const formattedDate = moment(expired_date).format('YYYYMMDD');
                                    batch = formattedDate
                                } else {
                                    batch = ""
                                }
                            } else {
                                batch = el.batch
                            }
                            let comboQty = el.combo_qty
                          const newItem = {
                            uid: `${el.sales_return_line_id}-${this.items.length}`,
                            item_code: el.item_code,
                            item_name: el.item_name,
                            item_unit: el.item_unit,
                            item_unit_id: el.item_unit_id,
                            item_unit_id_return: el.item_unit_id_return,
                            qty: el.qty,
                            quantity: returnQty,
                            pickup_qty: pickupQty,
                            delta_quantity: el.delta_quantity,
                            batch: batch,
                            expired_date: expired_date,
                            // checked_status: el.checked_status,
                            checked_status_value: { label: 'Bad', value: 'Bad' },
                            hideFields: (sameitem == el.item_code + el.item_unit + returnQty + el.sales_return_line_id) ? true : false,
                            batch_external: el.batch_external,
                            expired_date_from_so: el.expired_date_so,
                            batch_so: el.batch_so,
                            batch_external_so: batch_external_so,
                            setting_ed: el.is_expired,
                            setting_batch: el.name,
                            child_item : false,
                            supplier_code: el.supplier_code,
                            item_id: el.item_id,
                            amount_uom: el.amount_uom,
                            amount_uom_receive: amountUomReceive,
                            supplier_id: el.supplier_id,
                            sales_return_line_id: el.sales_return_line_id,
                            shelf_life_id: 0,
                            shelf_life_day: 0,
                            shelf_life_status: "",
                            shelf_life_status_view: "",
                            combo_id: el.combo_id,
                            combo_code: el.combo_code,
                            combo_name: el.combo_name,
                            qty_combo: comboQty,
                            combo_group: el.combo_id ? `${el.combo_id}-0` : null,
                            combo_qty_receive: 0,
                            // qty_per_set: returnQty / comboQty
                            qty_per_set: el.combo_item_quantity,
                            is_child_combo: false
                          }
                          this.items.push(newItem)
                          sameitem = el.item_code + el.item_unit + returnQty + el.sales_return_line_id
                        })
                        this.data.fileUrl = resp.data.file_url
                        this.$vs.loading.close();
                    } else {
                        this.$vs.loading.close();
                    }
                });
        },
        handleBack() {
            this.$router.push({
                name: this.$store.state.inbound.customerReturn.baseRouterName,
            });
        },
        handleChangeAttachment(event) {
            this.file = event.target.files ? event.target.files[0] : null;
        },
        handleSubmit(isConfirm = false) {
            var proceed = true;
            try{
                // validasi quantity normal items
                const groupedBySalesReturnLine = this.items.reduce((accumulator, current) => {
                    const salesReturnLineID = current.sales_return_line_id

                    // Fallback hanya bila data lama belum memiliki sales_return_line_id.
                    const key = salesReturnLineID
                        ? `srl-${salesReturnLineID}`
                        : `fallback-${current.item_code}-${current.item_unit}-${current.quantity}`

                    const amountUom = Number(current.amount_uom || 0)
                    const amountUomReceive = Number(current.amount_uom_receive || 0)

                    if (!accumulator[key]) {
                        const originalQty = current.pickup_qty != 0
                            ? Number(current.pickup_qty)
                            : Number(current.quantity)

                        accumulator[key] = {
                            itemCode: current.item_code + " - " + current.item_unit + " - " + current.quantity,
                            itemUnit: current.item_unit,
                            salesReturnLineID,
                            sum: 0,
                            qty: amountUom === amountUomReceive
                                ? originalQty
                                : originalQty * amountUom,
                        }
                    }

                    const qty = Number(current.qty || 0)

                    accumulator[key].sum +=
                        amountUom === amountUomReceive
                            ? qty
                            : qty * amountUomReceive

                    return accumulator
                }, {})

                for (const key in groupedBySalesReturnLine) {
                    const group = groupedBySalesReturnLine[key]

                    if (group.qty < group.sum) {
                        this.$vs.dialog({
                            type: 'alert',
                            color: 'danger',
                            title: 'Information',
                            text: `Quantity of item ${group.itemCode} must not exceed ${group.qty}`,
                            acceptText: 'OK',
                        })

                        proceed = false
                        throw new Error('BreakException')
                    }

                    if (group.qty !== group.sum) {
                        this.data.is_partial = 'yes'
                    }
                }

                // validasi quantity combo items
                this.groupedComboItems.forEach((group) => {
                    const comboQtyReceive = Number(group.combo_qty_receive || 0)
                    const comboQty = Number(group.qty_combo || 0)

                    if (comboQtyReceive > comboQty) {
                        this.$vs.dialog({
                            type: 'alert',
                            color: 'danger',
                            title: 'Information',
                            text: `Combo quantity for ${group.combo_code || group.combo_name || 'this combo'} must not exceed ${group.qty_combo} SET`,
                            acceptText: 'OK',
                        })

                        proceed = false
                        throw new Error('BreakException')
                    }

                    const itemQtyByGroup = {}

                    group.items.forEach((item) => {
                        const itemKey = `${item.item_id || item.item_code}-${item.item_unit || ''}`
                        const qtyPerSet = Number(item.qty_per_set || 0)

                        if (!itemQtyByGroup[itemKey]) {
                            itemQtyByGroup[itemKey] = {
                                itemCode: item.item_code,
                                itemUnit: item.item_unit,
                                qty: 0,
                                qtyPerSet,
                            }
                        }

                        itemQtyByGroup[itemKey].qty += Number(item.qty || 0)

                        if (qtyPerSet > 0 && itemQtyByGroup[itemKey].qtyPerSet === 0) {
                            itemQtyByGroup[itemKey].qtyPerSet = qtyPerSet
                        }
                    })

                    Object.values(itemQtyByGroup).forEach((itemGroup) => {
                        const qtyPerSet = Number(itemGroup.qtyPerSet || 0)
                        const maxQtyForSet = comboQtyReceive * qtyPerSet

                        if (qtyPerSet > 0 && itemGroup.qty !== maxQtyForSet) {
                            this.$vs.dialog({
                                type: 'alert',
                                color: 'danger',
                                title: 'Information',
                                text: `Quantity of item '${itemGroup.itemCode} - ${itemGroup.itemUnit}' for combo ${group.combo_code || group.combo_name || 'this combo'} must be exactly ${maxQtyForSet}`,
                                acceptText: 'OK',
                            })

                            proceed = false
                            throw new Error('BreakException')
                        }
                    })
                })
                
                let TotalQtyReceive = 0;
                this.items.forEach((el, idx) => { 
                    TotalQtyReceive += parseInt(el.qty);                    
                    if (this.items[idx].batch == null || this.items[idx].batch == '') {
                        this.$vs.dialog({
                            type: 'alert',
                            color: 'danger',
                            title: 'Information',
                            text: 'Batch is required!',
                            acceptText: 'OK',
                        });
                        proceed = false
                        throw new Error('BreakException');
                    }else if (this.items[idx].expired_date == null || this.items[idx].expired_date == ''){
                        this.$vs.dialog({
                            type: 'alert',
                            color: 'danger',
                            title: 'Information',
                            text: 'Expired date is required!',
                            acceptText: 'OK',
                        });
                        proceed = false
                        throw new Error('BreakException');
                    } else if(this.items[idx].checked_status_value == null || this.items[idx].checked_status_value == ''){
                        this.$vs.dialog({
                            type: 'alert',
                            color: 'danger',
                            title: 'Information',
                            text: 'Checked status is required!',
                            acceptText: 'OK',
                        });
                        proceed = false
                        throw new Error('BreakException');   
                    } else if(this.items[idx].supplier == null){
                        this.$vs.dialog({
                            type: 'alert',
                            color: 'danger',
                            title: 'Information',
                            text: 'Supplier is required!',
                            acceptText: 'OK',
                        });
                        proceed = false
                        throw new Error('BreakException');   
                    } else {
                        proceed = true
                    }
                });
                if (TotalQtyReceive == 0){
                    this.$vs.dialog({
                        type: 'alert',
                        color: 'danger',
                        title: 'Information',
                        text: 'Must at least receive one item !',
                        acceptText: 'OK',
                    });
                    proceed = false
                    throw new Error('BreakException');
                } else {
                    proceed = true
                } 
            }catch (e) {
                if (e.message !== 'BreakException') throw e;
            }
            if(proceed){
                if(isConfirm){
                    this.data.status = 2,
                    this.data.confirm = 1
                }
                this.data.receive_date = moment(this.data.receive_date).format('YYYY-MM-DD')
                let itemsMap = {};
                this.items.forEach((item, index) => {
                    let key = `${item.item_code}-${item.item_unit}-${item.sales_return_line_id}`;
                    if (!itemsMap[key]) {
                        itemsMap[key] = [];
                    }
                    itemsMap[key].push(index);
                });
                this.items.forEach((val, i) => {
                    let key = `${val.item_code}-${val.item_unit}-${val.sales_return_line_id}`;
                    let indices = itemsMap[key];
                    let lastIndex = indices[indices.length - 1];

                    if (i === lastIndex && this.items[i].delta_quantity > 0) {
                        this.items[i].is_partial = 1;
                    } else {
                        this.items[i].is_partial = 0;
                    }
                    this.items[i].expired_date = moment(val.expired_date).format('YYYY-MM-DD')
                    this.items[i].checked_status = val.checked_status_value.value
                    if (val.combo_id > 0){
                        this.items[i].item_unit_id = val.item_unit_id_return
                        this.items[i].amount_uom_receive = val.amount_uom
                    }
                })
    
                let formData = new FormData();
                console.log('item',this.items)
                console.log('data',this.data)
                formData.append("file", this.file);
                formData.append("data", JSON.stringify(this.data))
                formData.append("lines", JSON.stringify(this.items))
                this.$vs.loading();
                let http = null
    
                if (this.data.srr_id != null) {
                    http = this.$http.put(this.$store.state.inbound.customerReturn.baseUrlPath + "/" + this.data.srr_id, formData)
                } else {
                    http = this.$http.post(this.$store.state.inbound.customerReturn.baseUrlPath, formData)
                }
    
                http.then((resp) => {
                    console.log(resp)
                    if (resp.code == 200) {
                        this.$vs.notify({
                            color: "success",
                            title: "Success",
                            text: resp.message,
                            position: "top-right",
                            iconPack: "feather",
                            icon: "icon-x-circle",
                        });
    
                        this.$vs.loading.close();
                        this.draw++;
                        this.handleBack()
                    } else {
                        this.$vs.loading.close();
                        this.showErrorDialog = true;
                        this.errorMessages = [resp.message];
                        // this.$vs.notify({
                        //     color: "danger",
                        //     title: "Error",
                        //     text: "test",
                        //     position: "top-right",
                        //     iconPack: "feather",
                        //     icon: "icon-x-circle",
                        //     time: 10000,
                        // });
                    }
                })
            }
        },
        calculate(index){
            // this.items[index].qty = this.items[index].qty.replace(/\D/g, '');
            // if(this.items[index].hideFields == true){
            //     this.items[index].delta_quantity = this.items[index - 1].delta_quantity - (this.items[index].qty * this.items[index].amount_uom_receive);
            // } else {
            //     if(this.items[index].pickup_qty != 0){
            //         this.items[index].delta_quantity = (this.items[index].pickup_qty * this.items[index].amount_uom) - (this.items[index].qty * this.items[index].amount_uom_receive);
            //     } else {
            //         this.items[index].delta_quantity = (this.items[index].quantity * this.items[index].amount_uom) - (this.items[index].qty * this.items[index].amount_uom_receive);
            //     }
            // }
            this.items[index].qty = this.items[index].qty.replace(/\D/g, '');
            const currentItem = this.items[index];
            let previousDeltaQuantity = 0; // Menyimpan nilai delta dari loop sebelumnya

            this.items.forEach((val, idx) => {
                // Cek kelompok item berdasarkan kode, unit, dan quantity
                if (val.item_code === currentItem.item_code &&
                    val.item_unit === currentItem.item_unit &&
                    val.quantity === currentItem.quantity) {

                    if (val.hideFields === false) {
                        // Iterasi pertama untuk kelompok item (hideFields == false)
                        if (val.pickup_qty && val.pickup_qty !== 0) {
                            // Jika ada pickup_qty, gunakan dalam perhitungan
                            val.delta_quantity = (val.pickup_qty * val.amount_uom) - (val.qty * val.amount_uom_receive);
                        } else if(val.qty && val.qty !== 0){
                            // Jika tidak ada pickup_qty, gunakan quantity
                            val.delta_quantity = (val.quantity * val.amount_uom) - (val.qty * val.amount_uom_receive);
                        }
                        // Set nilai delta_quantity ini sebagai nilai awal untuk iterasi berikutnya
                        previousDeltaQuantity = val.delta_quantity;
                        console.log("parent delta",val.delta_quantity)
                    } else {
                        // Iterasi selanjutnya dalam kelompok (hideFields == true)
                        // Menggunakan delta_quantity dari iterasi sebelumnya
                        val.delta_quantity = previousDeltaQuantity - (val.qty * val.amount_uom_receive);
                        // Perbarui nilai previousDeltaQuantity untuk digunakan dalam iterasi berikutnya
                        previousDeltaQuantity = val.delta_quantity;
                        console.log("child delta",val.delta_quantity)
                    }
                }
            });
        },
        calculateChildCombo(index){
            this.items[index].qty = this.items[index].qty.replace(/\D/g, '');
            const currentItem = this.items[index];
            let previousDeltaQuantity = 0; // Menyimpan nilai delta dari loop sebelumnya

            this.items.forEach((val, idx) => {
                // Cek kelompok item berdasarkan kode, unit, dan quantity
                if (val.item_code === currentItem.item_code &&
                    val.item_unit === currentItem.item_unit &&
                    val.quantity === currentItem.quantity) {

                    if (val.hideFields === false) {
                        // Iterasi pertama untuk kelompok item (hideFields == false)
                        if (val.pickup_qty && val.pickup_qty !== 0) {
                            // Jika ada pickup_qty, gunakan dalam perhitungan
                            val.delta_quantity = (val.pickup_qty) - (val.qty);
                        } else if(val.qty && val.qty !== 0){
                            // Jika tidak ada pickup_qty, gunakan quantity
                            val.delta_quantity = (val.quantity) - (val.qty);
                        }
                        // Set nilai delta_quantity ini sebagai nilai awal untuk iterasi berikutnya
                        previousDeltaQuantity = val.delta_quantity;
                        console.log("parent delta",val.delta_quantity)
                    } else {
                        // Iterasi selanjutnya dalam kelompok (hideFields == true)
                        // Menggunakan delta_quantity dari iterasi sebelumnya
                        val.delta_quantity = previousDeltaQuantity - (val.qty);
                        // Perbarui nilai previousDeltaQuantity untuk digunakan dalam iterasi berikutnya
                        previousDeltaQuantity = val.delta_quantity;
                        console.log("child delta",val.delta_quantity)
                    }
                }
            });
        },
        openTab(uri) {
            window.open(uri)
        },
        getPermission() {
            this.$vs.loading();
            this.$http
                .get("/api/account/v1/permission", {
                params: {
                    module: "customer-return",
                    source: "WMS"
                }
                })
                .then((resp) => {
                this.$vs.loading.close();
                if (resp.code === 200) {
                    this.permission = resp.data;
                } else {
                    this.$vs.notify({
                    color: "danger",
                    title: "Error",
                    text: resp.message,
                    position: "top-right",
                    iconPack: "feather",
                    icon: "icon-x-circle",
                    });
                }
            });
        },
        // getShelfLifeBulkParams() {
        //     const params = [];

        //     this.items.forEach(item => {
        //         if (item.supplier && item.supplier.id) {
        //             params.push({
        //                 item_id: item.item_id,
        //                 supplier_id: item.supplier.id
        //             });
        //         }
        //     });

        //     // remove duplicate
        //     return [...new Map(params.map(p => 
        //         [`${p.item_id}-${p.supplier_id}`, p]
        //     )).values()];
        // },
        // getShelfLifeBulk() {
        //     const params = this.getShelfLifeBulkParams();
        //     if (params.length === 0) return;

        //     this.$vs.loading();

        //     this.$http.post(
        //         this.$store.state.inbound.customerReturn.baseUrlPath + "/shelf-life/bulk",
        //         { items: params }
        //     ).then((resp) => {
        //         this.$vs.loading.close();

        //         if (resp.code === 200) {
        //             if (resp.data.records){
        //                 this.applyShelfLife(resp.data.records);
        //             }
        //             this.shelfLifeLoaded = true;
        //         }
        //     });
        // },
        // applyShelfLife(data) {
        //     const map = new Map();
        //     data.forEach(d => {
        //         map.set(d.item_id + "-" + d.supplier_id, d);
        //     });

        //     this.items.forEach(item => {
        //         const supplierId = (item.supplier && item.supplier.id)
        //             ? item.supplier.id
        //             : item.supplier_id;

        //         const key = item.item_id + "-" + supplierId;

        //         if (map.has(key)) {
        //             const result = map.get(key);

        //             this.$set(item, "shelf_life_id", result.id);
        //             this.$set(item, "shelf_life_day", result.in_day_gir);
        //         }
        //     });

        // },
        // updateShelfLife(index) {
        //     const item_id = this.items[index].item_id
        //     const supplier_id = this.items[index].supplier_id
        //     if (item_id > 0 && supplier_id > 0){
        //         this.getShelfLife(this.items[index].item_id, this.items[index].supplier_id, index)
        //     }
        // },
        // calculateShelfLifeStatus(index) {
        //     const item = this.items[index];
        //     const postingDate = this.data.receive_date;
        //     if (
        //         !postingDate ||
        //         !item.expired_date ||
        //         !item.shelf_life_id ||
        //         item.shelf_life_id === 0 ||
        //         !item.shelf_life_day
        //     ) {
        //         this.items[index].shelf_life_status = "";
        //         this.items[index].shelf_life_status_view = "";
        //         return "";
        //     }
        //     const posting = moment(postingDate, "YYYY-MM-DD");
        //     const expired = moment(item.expired_date, "YYYY-MM-DD");
        //     if (!posting.isValid() || !expired.isValid()) {
        //         this.items[index].shelf_life_status = "";
        //         this.items[index].shelf_life_status_view = "";
        //         return "";
        //     }
        //     const diffDays = expired.diff(posting, "days");

        //     let result = "";
        //     let result_view = "";

        //     if (diffDays >= item.shelf_life_day) {
        //         result = `Passed (${diffDays} Day)`;
        //         result_view = `Passed`;
        //     } else {
        //         result = `Failed (${diffDays} Day)`;
        //         result_view = `Shelf Life < ${item.shelf_life_day} Day`;
        //     }
        //     this.items[index].shelf_life_status = result;
        //     this.items[index].shelf_life_status_view = result_view;
        //     return result;
        // },
        // getShelfLife(item_id, supplier_id, index) {
        //     this.$vs.loading();
        //     this.$http
        //         .get(this.$store.state.inbound.customerReturn.baseUrlPath + "/shelf-life", {
        //         params: {
        //                 item_id : item_id,
        //                 supplier_id : supplier_id
        //             },
        //         })
        //         .then((resp) => {
        //         if (resp.code == 200) {
        //             // console.log("RESP Shelf Life",resp)
        //             this.items[index].shelf_life_id = resp.data.records.id
        //             this.items[index].shelf_life_day = resp.data.records.in_day_gir
        //             // update status shelf life
        //             this.calculateShelfLifeStatus(index)

        //             this.$vs.loading.close();
        //         } else {
        //             this.$vs.loading.close();
        //         }
        //         });
        //     },
        //     formatDateTime(s){
        //     const m = moment.parseZone(s);
        //     return m.format('YYYY-MM-DD HH:mm:ss')
        // },
        addItemCombo(group) {
            const comboSetCount = this.groupedComboItems.filter(
                g => g.combo_id === group.combo_id
            ).length

            const newGroupKey = `${group.combo_id}-${comboSetCount}`

            const newItems = group.items.map((item, index) => {
                return {
                    ...JSON.parse(JSON.stringify(item)),
                    uid: `${item.sales_return_line_id}-${this.items.length + index}`,
                    combo_group: newGroupKey,
                    combo_qty_receive: 0,
                    qty: 0,
                    hideFields: false,
                    child_item: true
                }
            })

            const lastIndex = this.items.reduce((last, current, index) => {
                if (current.combo_group === group.combo_group) {
                    last = index
                }
                return last
            }, -1)

            this.items.splice(lastIndex + 1, 0, ...newItems)
        },
        removeItemCombo(group) {
            const comboIndexes = []

            this.items.forEach((item, index) => {
                if (item.combo_id === group.combo_id) {
                    comboIndexes.push(index)
                }
            })

            const childItems = comboIndexes
                .map(index => ({ index, item: this.items[index] }))
                .filter(row => row.item.child_item)

            if (childItems.length === 0) {
                return
            }

            const removeCount = group.items.length
            const startIndex = childItems[childItems.length - removeCount].index

            this.items.splice(startIndex, removeCount)
        },
        isFirstComboGroup(group) {
            const firstGroup = this.groupedComboItems.find(
                g => g.combo_id === group.combo_id
            )

            return firstGroup && firstGroup.combo_group === group.combo_group
        },
        getItemIndex(uid) {
            return this.items.findIndex(item => item.uid === uid)
        },
        calculateCombo(group, value) {
            const comboQtyReceive = String(value || '').replace(/\D/g, '')

            // simpan ke item parent di this.items
            const parentIndex = this.items.findIndex(
                item => item.combo_group === group.combo_group
            )

            if (parentIndex === -1) return

            this.items[parentIndex].combo_qty_receive = parseInt(comboQtyReceive || 0)

            const qtyCombo = parseInt(group.qty_combo || 0)
            const receiveQty = parseInt(comboQtyReceive || 0)

            if (!qtyCombo || qtyCombo <= 0) {
                return
            }

            const targetItems = this.items.filter(
                item => item.combo_group === group.combo_group
            )

            targetItems.forEach(item => {
                const realIndex = this.getItemIndex(item.uid)
                const prevDeltaQty = this.items[realIndex].delta_quantity

                if (realIndex === -1) return

                const baseQty =
                    item.pickup_qty && item.pickup_qty !== 0
                        ? parseInt(item.pickup_qty)
                        : parseInt(item.quantity)

                const itemQty = Math.floor(receiveQty * item.qty_per_set)

                this.items[realIndex].qty = String(itemQty)

                if (prevDeltaQty > 0) {
                    this.items[realIndex].delta_quantity =
                        (prevDeltaQty) -
                        (itemQty)
                } else {
                    this.items[realIndex].delta_quantity =
                        (baseQty) -
                        (itemQty)
                }
            })
        },
    },
    computed: {
        disabledDatesObj() {
            const tomorrow = moment().add(1, 'day').startOf('day').toDate();
            return {
            from: tomorrow
            };
        },
        formatDate: () => {
            return (val) => {
                const momentDate = moment.utc(val);
                return momentDate.format('YYYY-MM-DD');
            };
        },
        hasPermission() {
            return (guardName) => {
                return this.permission.some((perm) => perm.GuardName === guardName);
            };
        },
        normalItems() {
            return this.items.filter(item => !item.combo_id || item.combo_id === 0)
        },
        comboItems() {
            return this.items.filter(item => item.combo_id && item.combo_id !== 0)
        },
        groupedComboItems() {
            const grouped = {}

            this.comboItems.forEach(item => {
                const groupKey = item.combo_group || `${item.combo_id}-0`

                if (!grouped[groupKey]) {
                    grouped[groupKey] = {
                        combo_group: groupKey,
                        combo_id: item.combo_id,
                        combo_code: item.combo_code,
                        combo_name: item.combo_name,
                        qty_combo: item.qty_combo,
                        combo_qty_receive: item.combo_qty_receive || '',
                        child_item: item.child_item,
                        items: []
                    }
                }

                grouped[groupKey].items.push(item)
            })

            return Object.values(grouped)
        }
    },
    watch: {
        // items: {
        //     handler(items) {
        //         var ready = items.every(function (item) {
        //             return item.item_id && (
        //                 (item.supplier && item.supplier.id) || item.supplier_id
        //             );
        //         });

        //         if (ready && !this.shelfLifeLoaded) {
        //             this.getShelfLifeBulk();
        //         }
        //     },
        //     deep: true
        // }
        // items: {
        //     handler(newItems, oldItems) {
        //     newItems.forEach((item, index) => {
        //         console.log("newItem",item.expired_date)
        //         console.log("oldItem",oldItems[index].expired_date)
        //         if (item.expired_date !== oldItems[index].expired_date) {
        //         this.updateBatch(index);
        //         }
        //     });
        //     },
        //     deep: true
        // }
        // items: {
        //     handler(newItems) {
        //         newItems.forEach(item => {
        //             console.log("items",item)
        //             this.$watch(() => item.qty, (newQty) => {
        //                 if(item.hideFields == true){
        //                     item.delta_quantity = item.delta_quantity - newQty;
        //                 } else {
        //                     item.delta_quantity = item.quantity - newQty;
        //                 }
        //             });
        //         });
        //     },
        //     deep: true,
        //     immediate: true
        // }
    }
}
</script>
